import React from 'react';

// Components
import Img from 'components/Img';
import Button from 'components/UiKit/Button';

// Navigation
import { useNavigate } from 'react-router-dom';

export const NotAuthorized: React.FC = () => {
	const navigate = useNavigate();

	const handlerChange = (url: string) => () => {
		navigate(`/auth?tab=${url}`, {
			state: 'isBiosearch'
		});
	};

	return (
		<div className="not-authorized flex flex-jc-center flex-ai-center flex-direction-column">
			<Img isSvg name="lockSvg" className="not-authorized__image mb20" />
			<h4 className="not-authorized__title mb10">Unlock the Full Potential</h4>
			<p className="not-authorized__text mb40">Please login to get all possibilities and advances of Biosearch</p>

			<div className="not-authorized__wrapper-btn flex flex-jc-center flex-ai-center">
				<Button variable="info" label="Log In" onPress={handlerChange('sign-in')} />
				<span className="ml20 mr20">OR</span>
				<Button variable="info" color="green" label="Sign Up" onPress={handlerChange('sign-up')} />
			</div>
		</div>
	);
};

export default NotAuthorized;
